import { useEffect, useState } from "react";

// ChatGPT tasarimlari filtresi: "all" = hepsi, "only" = yalniz ChatGPT,
// "hide" = ChatGPT'yi gizle. Tum tasarim listelerinde (Tasarimlar sayfasi +
// secim modallari) ortak; son secim tarayicida hatirlanir.
export type ChatGptFilter = "all" | "only" | "hide";
const KEY = "erc_filter_chatgpt";
const EVENT = "erc-filter-chatgpt";

function read(): ChatGptFilter {
  try {
    const v = localStorage.getItem(KEY);
    return v === "1" || v === "only" ? "only" : v === "hide" ? "hide" : "all";
  } catch { return "all"; }
}

export function useChatGptFilter(): [ChatGptFilter, (v: ChatGptFilter) => void] {
  const [mode, setMode] = useState<ChatGptFilter>(read);
  // Ayni sayfadaki diger listeler (or. sayfa + acik modal) esit kalsin
  useEffect(() => {
    const sync = () => setMode(read());
    window.addEventListener(EVENT, sync);
    window.addEventListener("storage", sync);
    return () => { window.removeEventListener(EVENT, sync); window.removeEventListener("storage", sync); };
  }, []);
  const set = (v: ChatGptFilter) => {
    try { localStorage.setItem(KEY, v); } catch { /* yalniz bu oturumda gecerli */ }
    setMode(v);
    window.dispatchEvent(new Event(EVENT));
  };
  return [mode, set];
}

/** API parametresi (all = gonderilmez) */
export const chatgptParam = (m: ChatGptFilter): "only" | "hide" | undefined => (m === "all" ? undefined : m);
